import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h3", { class: "text-[34px] h-11 leading-11 font-bold mb-4" }, "Школьное меню", -1)
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Комплексы ")
const _hoisted_3 = { class: "leading-tight" }
const _hoisted_4 = { class: "text-xs text-gray-400" }
const _hoisted_5 = { class: "leading-tight" }
const _hoisted_6 = { class: "text-xs text-gray-400" }

import { ref, computed } from "vue";

import { useAsync } from "@/use/useAsync";
import { useSchoolMenu } from "@/use/useSchoolMenu";
import { formatCurrency } from "@/utils";

import UiApp from "@/plugins/ui/components/app/UiApp.vue";
import UiCard from "@/plugins/ui/components/card/UiCard.vue";
import UiHeader from "@/plugins/ui/components/header/UiHeader.vue";
import UiSuspense from "@/plugins/ui/components/suspense/UiSuspense.vue";

import UiAppBar from "@/components/UiAppBar.vue";
import UiIcon from "@/components/ui/UiIcon.vue";
import UiSimpleCell from "@/components/ui/UiSimpleCell.vue";
import UiTab from "@/components/ui/UiTab.vue";
import UiTabs from "@/components/ui/UiTabs.vue";

import AppTabbar from "@/components/AppTabbar.vue";
import AppSidebar from "@/components/AppSidebar.vue";
import UiAppbar from "@/plugins/ui/components/appbar/UiAppbar.vue";
import UiIconBtn from "@/components/ui/UiIconBtn.vue";
import UiGroup from "@/plugins/ui/components/group/UiGroup.vue";
import UiCell from "@/plugins/ui/components/cell/UiCell.vue";
import UiPlaceholder from "@/plugins/ui/components/placeholder/UiPlaceholder.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'SchoolMenu',
  setup(__props) {

const { schoolMenu, hasMenu, fetchSchoolMenu } = useSchoolMenu();

const fetchData = useAsync(fetchSchoolMenu, true);

const filter = ref(-1);
const setFitler = (id: number) => (filter.value = id);

const filteredFoods = computed(
  () => schoolMenu.value?.types?.find((t) => t.id === filter.value)?.foods || []
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(UiApp, null, {
    header: _withCtx(() => [
      _createVNode(UiAppbar, {
        temporary: "",
        title: "Школьное меню"
      }, {
        right: _withCtx(() => [
          _createVNode(UiIconBtn, {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.replace('/settings'))),
            variant: "tertiary",
            icon: "Cog"
          })
        ]),
        _: 1
      })
    ]),
    footer: _withCtx(() => [
      _createVNode(AppTabbar)
    ]),
    sidebar: _withCtx(() => [
      _createVNode(AppSidebar)
    ]),
    default: _withCtx(() => [
      _hoisted_1,
      _createVNode(UiSuspense, {
        onRetry: _cache[2] || (_cache[2] = ($event: any) => (_unref(fetchData).execute())),
        pending: _unref(fetchData).isPending.value,
        failure: _unref(fetchData).isFailure.value,
        success: _unref(fetchData).isSuccess.value,
        variant: "screen",
        "has-retry": ""
      }, {
        default: _withCtx(() => [
          (_unref(schoolMenu) && _unref(hasMenu))
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createVNode(UiTabs, null, {
                  default: _withCtx(() => [
                    (_unref(schoolMenu).sets.length)
                      ? (_openBlock(), _createBlock(UiTab, {
                          key: 0,
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (setFitler(-1))),
                          active: filter.value === -1
                        }, {
                          default: _withCtx(() => [
                            _hoisted_2
                          ]),
                          _: 1
                        }, 8, ["active"]))
                      : _createCommentVNode("", true),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(schoolMenu).types, ({ name, id }) => {
                      return (_openBlock(), _createBlock(UiTab, {
                        onClick: ($event: any) => (setFitler(id)),
                        key: id,
                        active: filter.value === id
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(name), 1)
                        ]),
                        _: 2
                      }, 1032, ["onClick", "active"]))
                    }), 128))
                  ]),
                  _: 1
                }),
                (filter.value === -1)
                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_unref(schoolMenu).sets, (set) => {
                      return (_openBlock(), _createBlock(UiGroup, {
                        key: set.name
                      }, {
                        header: _withCtx(() => [
                          _createVNode(UiHeader, {
                            title: set.name,
                            description: set.description,
                            multiline: ""
                          }, null, 8, ["title", "description"])
                        ]),
                        default: _withCtx(() => [
                          _createVNode(UiCard, null, {
                            header: _withCtx(() => [
                              _createVNode(UiHeader, {
                                description: `Стоимость комплекса - ${_unref(formatCurrency)(
                      set.sum / 100
                    )}`,
                                multiline: ""
                              }, null, 8, ["description"])
                            ]),
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(set.foods, (food) => {
                                return (_openBlock(), _createBlock(UiCell, {
                                  key: food.id,
                                  multiline: ""
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("p", _hoisted_3, _toDisplayString(food.name), 1),
                                    _createElementVNode("p", _hoisted_4, " Количество (вес): " + _toDisplayString(food.weight), 1)
                                  ]),
                                  right: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_unref(formatCurrency)(food.price / 100)), 1)
                                  ]),
                                  _: 2
                                }, 1024))
                              }), 128))
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1024))
                    }), 128))
                  : (_openBlock(), _createBlock(UiCard, { key: 1 }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(filteredFoods), (food) => {
                          return (_openBlock(), _createBlock(UiCell, {
                            key: food.id,
                            multiline: ""
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("p", _hoisted_5, _toDisplayString(food.name), 1),
                              _createElementVNode("p", _hoisted_6, " Количество (вес): " + _toDisplayString(food.weight), 1)
                            ]),
                            right: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_unref(formatCurrency)(food.price / 100)), 1)
                            ]),
                            _: 2
                          }, 1024))
                        }), 128))
                      ]),
                      _: 1
                    }))
              ], 64))
            : (_openBlock(), _createBlock(UiPlaceholder, {
                key: 1,
                icon: "EmojiSad",
                title: "Меню не найдено",
                description: "К сожалению, в вашей школе меню на сегодня отсутствует",
                "has-retry": "",
                screen: ""
              }))
        ]),
        _: 1
      }, 8, ["pending", "failure", "success"])
    ]),
    _: 1
  }))
}
}

})